"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsContextProvider = exports.NotificationsContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var defaults_1 = require("./defaults");
var states_1 = require("./states");
var notify_1 = require("../../services/notify");
var useLocalStorage_1 = require("../hooks/useLocalStorage");
var index_1 = require("./index");
var user_1 = require("./user");
exports.NotificationsContext = (0, react_1.createContext)({
    notifications: defaults_1.defaultConfig.notifications,
    fetchNotifications: defaults_1.defaultConfig.fetchNotifications,
    readNotify: defaults_1.defaultConfig.readNotify,
    readAllNotifications: defaults_1.defaultConfig.readAllNotifications,
});
var NotificationsContextProvider = function (_a) {
    var children = _a.children, defaults = _a.defaults, apiUrl = _a.apiUrl, ssrHydration = _a.ssrHydration;
    var abortControllers = (0, react_1.useRef)({});
    var token = (0, react_1.useContext)(user_1.UserContext).token;
    var _b = (0, useLocalStorage_1.useLocalStorage)("lms", "notifications", (0, index_1.getDefaultData)("notifications", __assign(__assign({}, defaults_1.defaultConfig), defaults)), ssrHydration), notifications = _b[0], setNotifications = _b[1];
    var fetchNotifications = (0, react_1.useCallback)(function (filter) {
        var _a;
        if (filter === void 0) { filter = {
            page: 0,
            per_page: 25,
        }; }
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "notifications/".concat(JSON.stringify(filter)),
                mode: "paginated",
                fetchAction: notify_1.getNotifications.bind(null, apiUrl)(token, filter, {
                    signal: (_a = abortControllers.current["notifications/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
                }),
                setState: setNotifications,
            })
            : Promise.reject("noToken");
    }, [token]);
    var readNotify = (0, react_1.useCallback)(function (id) {
        return token
            ? notify_1.readNotification
                .bind(null, apiUrl)(id, token)
                .then(function (response) {
                if (response.success) {
                    setNotifications(function (prevState) { return (__assign(__assign({}, prevState), { list: prevState.list
                            ? __assign(__assign({}, prevState.list), { data: prevState.list.data.filter(function (item) { return item.id !== id; }) }) : undefined, loading: false })); });
                }
            })
                .catch(function (error) {
                setNotifications(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error })); });
            })
            : Promise.reject("noToken");
    }, [token, notifications]);
    var readAllNotifications = (0, react_1.useCallback)(function () {
        return token
            ? notify_1.readAll
                .bind(null, apiUrl)(token)
                .then(function (response) {
                if (response.success) {
                    setNotifications(function (prevState) { return (__assign(__assign({}, prevState), { list: {
                            data: [],
                            meta: {
                                current_page: 0,
                                next_page_url: "",
                                last_page: 0,
                                path: "",
                                per_page: 25,
                                prev_page_url: null,
                                to: 0,
                                total: 0,
                                links: {
                                    first: "",
                                    last: "",
                                    next: "",
                                    prev: "",
                                },
                            },
                        }, loading: false })); });
                }
            })
                .catch(function (error) {
                setNotifications(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error })); });
            })
            : Promise.reject("noToken");
    }, [token, notifications]);
    return ((0, jsx_runtime_1.jsx)(exports.NotificationsContext.Provider, __assign({ value: {
            readAllNotifications: readAllNotifications,
            notifications: notifications,
            fetchNotifications: fetchNotifications,
            readNotify: readNotify,
        } }, { children: children })));
};
exports.NotificationsContextProvider = NotificationsContextProvider;
